import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    List,
    ListItem,
    ListItemText,
    ListItemSecondaryAction,
    Typography
} from '@mui/material';

type FedExDialogProps = {
    open: boolean;
    onClose: () => void;
    trackingNumbers: string[];
};

const FedExTrackingDialog: React.FC<FedExDialogProps> = ({ open, onClose, trackingNumbers }) => {
    const openFedExLink = (trackingNumber: string) => {
        const url = `https://www.fedex.com/fedextrack/?tracknumbers=${trackingNumber}`;
        window.open(url, '_blank');
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle sx={{fontWeight: "bold"}}>FEDEX DETAILS</DialogTitle>
            <DialogContent>
                {trackingNumbers.length === 0 ? (
                    <Typography>No tracking numbers found.</Typography>
                ) : (
                    <List style={{ padding: 10 }}>
                        {trackingNumbers.map((number, index) => (
                            <ListItem key={index} divider>
                                <ListItemText primary={number ? number : ""} />
                                <Button variant="outlined" onClick={() => openFedExLink(number)}>
                                    Track Shipment
                                </Button>
                            </ListItem>
                        ))}
                    </List>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} variant="contained">Close</Button>
            </DialogActions>
        </Dialog>
    );
};

export default FedExTrackingDialog;
